import React from 'react'
import "./navbar.css"
import Hamburger from '../assets/hamburger.svg';
import Logo from '../assets/elou.png';

export default function Navbar({fullpageAPI}) {
  const handleOpenClick = () => {
    document.querySelector("nav").style.left = 0;
  }

  const handleCloseClick = () => {
    document.querySelector("nav").style.left = "-500vw";
  }
  return (
    <>
    <div className='mob-nav'>
      <div className='mob-logo'>
        <img alt='logo' src={Logo} />
      </div>
      <div className='ham'>
        <img alt="ham" src={Hamburger} onClick={() => handleOpenClick()} />
      </div>
    </div>
    <nav>
      <div className='x' onClick={() => handleCloseClick()}>
        x
      </div>
      <div className='logo'>
        <img alt='logo' src={Logo} />
      </div>
      <ul className='menu'>
        <li onClick={() =>{ fullpageAPI.moveTo("Home");if(window.innerWidth < 786) handleCloseClick()}}>Home</li>
        <li onClick={() =>{ fullpageAPI.moveTo("Skills");if(window.innerWidth < 786) handleCloseClick()}}>Skills</li>
        <li onClick={() =>{ fullpageAPI.moveTo("Projects");if(window.innerWidth < 786) handleCloseClick()}}>Projects</li>
        <li onClick={() =>{ fullpageAPI.moveTo("Socials");if(window.innerWidth < 786) handleCloseClick()}}>Socials</li>
        <li onClick={() =>{ fullpageAPI.moveTo("Email-me");if(window.innerWidth < 786) handleCloseClick()}}>Email me</li>
      </ul>
    </nav>
    </>
  )
}
